import HalftoneHero from './components/HalftoneHero';

export default function Home() {
  return (
    <main className="w-full bg-white">
      <HalftoneHero />
    </main>
  );
}